(function() {
    const wordsArray = [
        "\u039F \u03C3\u03BA\u03CD\u03BB\u03BF\u03C2 \u03BC\u03BF\u03C5 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C6\u03BF\u03B2\u03B9\u03BA\u03CC\u03C2...",
        "\u039F \u03C3\u03BA\u03CD\u03BB\u03BF\u03C2 \u03BC\u03BF\u03C5 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B1\u03BD\u03C4\u03B9\u03B4\u03C1\u03B1\u03C3\u03C4\u03B9\u03BA\u03CC\u03C2...",
        "\u039F \u03C3\u03BA\u03CD\u03BB\u03BF\u03C2 \u03BC\u03BF\u03C5 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BA\u03BF\u03C5\u03C4\u03AC\u03B2\u03B9...",
        "\u039F \u03C3\u03BA\u03CD\u03BB\u03BF\u03C2 \u03BC\u03BF\u03C5 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BE\u03B5\u03C1\u03BF\u03BA\u03AD\u03C6\u03B1\u03BB\u03BF\u03C2...",
        "\u039F \u03C3\u03BA\u03CD\u03BB\u03BF\u03C2 \u03BC\u03BF\u03C5 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B5\u03BA\u03BD\u03B5\u03C5\u03C1\u03B9\u03C3\u03C4\u03B9\u03BA\u03CC\u03C2...",
        "\u039F \u03C3\u03BA\u03CD\u03BB\u03BF\u03C2 \u03BC\u03BF\u03C5 \u03B3\u03B1\u03C5\u03B3\u03AF\u03B6\u03B5\u03B9 \u03B1\u03BA\u03B1\u03C4\u03AC\u03C0\u03B1\u03C5\u03C3\u03C4\u03B1...",
        "\u039F \u03C3\u03BA\u03CD\u03BB\u03BF\u03C2 \u03BC\u03BF\u03C5 \u03C0\u03B7\u03B4\u03AC\u03B5\u03B9 \u03C0\u03AC\u03BD\u03C9 \u03BC\u03B1\u03C2...",
        "\u039F \u03C3\u03BA\u03CD\u03BB\u03BF\u03C2 \u03BC\u03BF\u03C5 \u03BB\u03B5\u03C1\u03CE\u03BD\u03B5\u03B9 \u03BC\u03AD\u03C3\u03B1 \u03C3\u03C4\u03BF \u03C3\u03C0\u03AF\u03C4\u03B9...",
        "\u039F \u03C3\u03BA\u03CD\u03BB\u03BF\u03C2 \u03BC\u03BF\u03C5 \u03B4\u03B5\u03BD \u03B1\u03BA\u03BF\u03CD\u03B5\u03B9...",
        "\u039F \u03C3\u03BA\u03CD\u03BB\u03BF\u03C2 \u03BC\u03BF\u03C5 \u03B4\u03B5\u03BD \u03B7\u03C1\u03B5\u03BC\u03B5\u03AF \u03BC\u03B5 \u03C4\u03AF\u03C0\u03BF\u03C4\u03B1...",
        "\u039F \u03C3\u03BA\u03CD\u03BB\u03BF\u03C2 \u03BC\u03BF\u03C5 \u03BC\u03B5 \u03C4\u03C1\u03B1\u03B2\u03AC\u03B5\u03B9 \u03C3\u03C4\u03B7\u03BD \u03B2\u03CC\u03BB\u03C4\u03B1..."
    ];
    // Wait for the DOM content to fully load
    document.addEventListener("DOMContentLoaded", function() {
        // Initialize the Typed.js instance
        var typed = new Typed('#typing', {
            strings: wordsArray,
            typeSpeed: 80,
            backSpeed: 30,
            backDelay: 1000,
            shuffle: true,
            loop: true
        });
    });
// Typed.js can be found at https://github.com/mattboldt/typed.js
})();


(function() {
    document.addEventListener("DOMContentLoaded", function() {
        document.querySelectorAll('a[href^="#"]').forEach((anchor)=>{
            anchor.addEventListener('click', function(e) {
                e.preventDefault();
                const target = document.querySelector(this.getAttribute('href'));
                if (target) target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            });
        });
    });
})();


(function() {
    document.addEventListener("DOMContentLoaded", ()=>{
        const closeButton = document.querySelector(".banner-close-button");
        const offerBanner = document.getElementById("offer");
        closeButton.addEventListener("click", ()=>{
            offerBanner.style.display = "none"; // Hides the banner
        });
    });
})();


(function() {
    const button = document.getElementById("obfuscateBtn");
    // Add the event listener
    button.addEventListener("click", function() {
        // Obfuscate email
        const emailParts = [
            "geniusdogsgr",
            "gmail.com"
        ]; // Replace with your email
        const email = document.getElementById("eml");
        if (email) {
            // email.innerHTML = `<a href="mailto:${emailParts[0]}@${emailParts[1]}">${emailParts[0]}@${emailParts[1]}</a>`;
            email.innerHTML = `${emailParts[0]}@${emailParts[1]}`;
            email.href = `mailto:${emailParts[0]}@${emailParts[1]}`;
        } else console.error("Element with ID 'eml' not found.");
        // Obfuscate phone number
        const phoneParts = [
            "+30",
            "690",
            "639",
            "6321"
        ]; // Replace with your phone number
        const phoneNumber = document.getElementById("phnnbr");
        if (phoneNumber) {
            phoneNumber.innerHTML = phoneParts.join(" ");
            phoneNumber.href = "tel:" + phoneParts.join("");
        } else console.error("Element with ID 'phnnbr' not found.");
        // Select all elements with the class 'contact-row'
        const contactRows = document.querySelectorAll('.contact-row');
        // Loop through each element and change the display property
        contactRows.forEach(function(row) {
            row.style.display = 'flex';
        });
        // Remove the button
        button.style.display = 'none';
    });
})();


(function() {
    // const button = document.getElementById("sbmtbtn");
    const form = document.querySelector('form');
    const confirmationMessage = document.getElementById('confirmation-message');
    // const formContainer = document.getElementById('form-container');
    // Add the event listener to the form
    form.addEventListener('submit', function(event) {
        // Prevent default form submission
        event.preventDefault();
        // Display confirmation message
        if (confirmationMessage) confirmationMessage.style.display = 'flex';
        // Submit the form programmatically
        this.submit();
    });
})();


(function() {
    // Get the elements
    const btn = document.getElementById('navbar-button');
    const navbar = document.getElementById('navbar');
    const content = document.getElementById('navbar-content');
    // Function to toggle the menu visibility
    btn.addEventListener('click', ()=>{
        navbar.classList.toggle('active'); // Add or remove the 'active' class
        content.classList.toggle('active');
    });
    // Close the menu if a link is clicked
    const menuLinks = document.querySelectorAll('#navbar-content a');
    menuLinks.forEach((link)=>{
        link.addEventListener('click', ()=>{
            navbar.classList.remove('active'); // Close the menu when a link is clicked
            content.classList.remove('active'); // Close the menu when a link is clicked
        });
    });
})();


(function() {
    document.addEventListener("DOMContentLoaded", ()=>{
        const today = new Date();
        const currentYear = today.getFullYear();
        document.getElementById('current-year').textContent = currentYear;
        // Seasonal background overrides — CSS class drives the image, not inline styles
        const christmasRanges = [
            {
                start: new Date(currentYear, 11, 15),
                end: new Date(currentYear, 11, 31)
            },
            {
                start: new Date(currentYear, 0, 1),
                end: new Date(currentYear, 0, 7)
            }
        ];
        const heroSection = document.querySelector("#hero");
        if (heroSection) {
            const isChristmas = christmasRanges.some((r)=>today >= r.start && today <= r.end);
            heroSection.classList.toggle("christmas", isChristmas);
        }
    });
})();


(function() {
    const modal = document.getElementById('videoModal');
    const closeBtn = document.getElementById('closeModal');
    // Open modal on thumbnail click
    document.querySelectorAll('#carousel button').forEach((btn)=>{
        btn.addEventListener('click', (e)=>{
            const videoURL = btn.dataset.videourl;
            const payload = `https://www.tiktok.com/oembed?url=${videoURL}`;
            fetch(payload).then((response)=>response.json()).then((data)=>{
                const content = document.querySelector('.modal-content');
                content.innerHTML = `<button class="modal-close" id="closeModal">&times;</button>` + data.html;
                // Dynamically reload TikTok embed script
                const script = document.createElement('script');
                script.src = 'https://www.tiktok.com/embed.js';
                script.async = true;
                content.appendChild(script);
            }).catch((err)=>{
                document.querySelector('.modal-content').innerHTML = '<p>Failed to load video.</p>';
            });
            modal.style.display = 'flex';
        });
    });
    // Close modal on click or background
    modal.addEventListener('click', (e)=>{
        if (e.target === modal || e.target.id === 'closeModal') closeModal();
    });
    function closeModal() {
        modal.style.display = 'none';
        document.querySelector('.modal-content').innerHTML = ''; // Clear content
    }
})();




//# sourceMappingURL=Genius-Dogs-Website-2.d48c0ef4.js.map
